@if (openAddGrader || openConfirmDelete) {
<div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
  <div class="h-full w-full flex justify-center items-center">
    @if (openAddGrader) {
    <div class="items-center justify-center rounded-[16px] bg-white p-4 absolute min-w-96">
      <div class="mb-2 font-bold">
        Add Grader
      </div>
      <div class="flex w-full mb-1 input mt-2 border rounded overflow-hidden p-1">
        <fa-icon [icon]="faMagnifyingGlass" [style]="searchIconStyle" />
        <input type="text" class="flex-grow w-full border-0 bg-[#F6F7F8] outline-none text-xs" placeholder="Search"
          [(ngModel)]="examGraderSearchText" (ngModelChange)="debounceSearch()" />
      </div>
      <div class="flex flex-col">
        @for (grader of gradersThatCanBeAdded | slice:0:5; track grader) {
        <button aria-label="Add Grader" (click)="addGrader(grader)"
          class="group mt-2 hover:bg-gray-200 rounded-[4px] p-2 flex justify-between items-center">
          {{grader.display_name}}

          <span class="group-hover:text-slate-500 text-transparent flex gap-1 items-center">
            <span class="text-xs">
              {{grader.username}}
            </span>
            <fa-icon [icon]="faAdd" />
          </span>
        </button>
        }
        @if (graderSearchIsLoading) {
        <div>
          @for (item of [0,1,2]; track item) {
          <div class="animate-pulse h-[40px] mt-2 bg-gray-200 rounded-[4px] p-2 flex justify-between items-center">
          </div>
          }
        </div>
        }
      </div>
      <div class="flex justify-start mt-5">
        <outline-button (click)="cancelGraderAdd()" text="Cancel" />
      </div>
    </div>
    }
    @if (openConfirmDelete && graderToBeDeleted != null) {
    <div class="rounded-[16px] bg-white p-4 absolute">
      <h1 class="font-semibold text-lg">Remove Grader</h1>
      <hr>
      <div class="py-4">
        <p class="text-gray-700">Are you sure you want to remove <b>{{graderToBeDeleted.display_name}}</b> as a grader?
        </p>
      </div>
      <div class="flex justify-end items-center gap-1 mt-5">
        <outline-button [marginRight]="true" (click)="cancelGraderDelete()" text="Cancel" />
        <full-button (click)="confirmGraderDelete()" text="Confirm" />
      </div>
    </div>
    }
  </div>
</div>
}
<breadcrumb endText="Exam Graders" [navigations]="breadcrumbNavs" />
<div class="m-8">
  <div class="flex flex-row justify-between items-center mb-4">
    <h1 class="font-semibold text-xl">
      Exam Graders
    </h1>
    <outline-button [faIcon]="faAdd" (click)="openAddGrader = true" text="Add Grader" />
  </div>
  <table class="w-full table-fixed border-separate border-spacing-0">
    <colgroup>
      <col />
      <col class="w-[220px]" />
      <col class="w-[140px]" />
    </colgroup>
    <thead>
      <tr class="h-[48px] text-left text-gray-500 text-xs font-semibold uppercase leading-tight">
        <th scope="col" class="bg-[#F4F6F8] rounded-l-[4px] pl-[16px] pr-2 font-semibold">
          <button type="button" aria-label="Toggle Sort By Name" (click)="toggleNameSort()"
            class="inline-flex items-center gap-1 uppercase font-semibold hover:text-gray-700">
            Name
            <fa-icon [icon]="sortByName ? faChevronDown : faChevronUp" class="text-[10px]" />
          </button>
        </th>
        <th scope="col" class="bg-[#F4F6F8] px-2 font-semibold">
          <button type="button" aria-label="Toggle Sort By Date" (click)="toggleDateSort()"
            class="inline-flex items-center gap-1 uppercase font-semibold hover:text-gray-700">
            Date Added
            <fa-icon [icon]="sortByDate ? faChevronDown : faChevronUp" class="text-[10px]" />
          </button>
        </th>
        <th scope="col" class="bg-[#F4F6F8] rounded-r-[4px] pl-2 pr-[16px]">
          <span class="sr-only">Actions</span>
        </th>
      </tr>
    </thead>
    <tbody>
      @for (grader of graderResponse; track grader; let i = $index) {
      <tr class="hover:bg-[#F9FAFB] transition-colors">
        <td class="pl-[16px] pr-2 py-3 align-middle border-b border-[#F1F3F5] text-sm">
          <div class="truncate font-medium text-black/90">{{grader.display_name}}</div>
          <div class="truncate text-xs text-gray-500">{{grader.username}}</div>
        </td>
        <td class="px-2 py-3 align-middle border-b border-[#F1F3F5] text-sm text-gray-600">
          {{grader.assigned_time | date: 'short'}}
        </td>
        <td class="pl-2 pr-[16px] py-3 align-middle border-b border-[#F1F3F5]">
          <div class="flex items-center justify-end">
            <button type="button" (click)="openGraderDelete(i)"
              class="flex items-center gap-[4px] text-sm text-[#CC0033] hover:underline">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M7 21C6.45 21 5.97933 20.8043 5.588 20.413C5.19667 20.0217 5.00067 19.5507 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.8043 20.021 18.413 20.413C18.0217 20.805 17.5507 21.0007 17 21H7ZM17 6H7V19H17V6ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z"
                  fill="#CC0033" />
              </svg>
              Remove
            </button>
          </div>
        </td>
      </tr>
      } @empty {
      <tr>
        <td colspan="3" class="py-10 text-center text-sm text-gray-500">
          No graders assigned
        </td>
      </tr>
      }
    </tbody>
  </table>
</div>
